import React from "react"
import { Card, CardContent, Box, Skeleton, Divider } from "@mui/material"

const OverviewCardSkeleton = () => {
  return (
    <Card
      sx={{
        minWidth: "264px",
        height: "208px",
        flexShrink: 0,
        padding: 0,
        boxShadow: "none",
        border: "1px solid #E5E9EC",
        borderRadius: "8px",
      }}
    >
      <CardContent
        sx={{
          padding: 0,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          "&:last-child": { paddingBottom: 0 },
        }}
      >
        <Box sx={{ padding: "16px 24px 16px 24px" }}>
          <Skeleton
            variant="text"
            width="60%"
            height={24}
            sx={{ marginBottom: "8px" }}
          />

          <Skeleton
            variant="text"
            width="80%"
            height={18}
          />
        </Box>

        <Divider
          sx={{
            borderColor: "#E5E9EC",
            width: "100%",
          }}
        />

        <Box
          sx={{
            padding: "16px 24px 24px 24px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "14px",
          }}
        >
          {[1, 2, 3].map((index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Skeleton
                variant="text"
                width="40%"
                height={18}
              />
              <Skeleton
                variant="text"
                width="20%"
                height={18}
              />
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  )
}

export default OverviewCardSkeleton
